// Generato da 00-strumenti/porta-in-shopify.py — non modificare a mano
/* ---------- POOL VINI LIVE (template Shopify) ----------
   I vini arrivano dalla collezione del gioco via Section Rendering API (sections/gioco-a-tavola-dati.liquid, ?section_id=…),
   una pagina da 250 scelta dal mese: stesso pool per tutti nel mese, cambia ogni mese, nessun job. */
const ROOT=document.getElementById('tannico-a-tavola');
const ROOT_URL=(ROOT.dataset.root||'/').replace(/\/?$/,'/');
const POOL_URL=ROOT.dataset.pool;
const POOL_COUNT=+ROOT.dataset.count||0;
// solo se stai provando un tema in anteprima (preview_theme_id nell'URL): mai per i clienti, anche se il tema
// servito non è "main" (A/B test: ruoli "unpublished"/"treatment") — la richiesta va allo stesso tema della pagina
const PREVIEW_ID=new URLSearchParams(location.search).get('preview_theme_id');
const THEME_QS=PREVIEW_ID&&/^\d+$/.test(PREVIEW_ID)?`&preview_theme_id=${PREVIEW_ID}`:'';

// Regola "stile di gioco" calcolata dai metafield Shopify, per il pool live del template.
// Input (dal JSON che la section Liquid stampa per ogni prodotto):
//   typology    handle del 1° metaobject custom.typologies: rosso, bianco, spumante, champagne, rose, dolce, liquoroso, orange-wine
//               (NON product.type: lì Porto/Marsala sono "Altro" e gli orange sono "Bianco")
//   chars       handle dei metaobject custom.characteristics   es. ["acciaio","fresco","legno"]
//   appellation custom.appellation                    es. "Fiano di Avellino DOCG"
//   title       product.title
//   price       prezzo variante in euro (numero)
//   bottleSize  custom.bottle_size                    es. "0.75L", "0.5L"
// Calibrata il 15/10/2026 su 100 vini già classificati da build.py: 76% di accordo, e nella
// maggior parte dei disaccordi la nuova etichetta è più corretta (es. rossi "corposo, tannico" prima "leggeri").

const STRUCT = { corposo: 2, importante: 2, barricato: 1.5, tannico: 1, legno: 1, complesso: 1, evoluto: 1, alcolico: 0.5, speziato: 0.5 };
const LIGHT = { acciaio: -1.5, giovane: -1, fresco: -0.5, fruttato: -0.5, erbaceo: -0.5, morbido: -0.5, sapido: -0.25 };
// denominazioni "importanti": da sole spingono verso strutturato
const BIG = /barolo|barbaresco|brunello|amarone|taurasi|bolgheri superiore|sagrantino|gran reserva|riserva|hermitage|pauillac|margaux|ch[aâ]teauneuf|fiano di avellino|greco di tufo|grand cru|1er cru|premier cru|condrieu|savenni[eè]res|timorasso|meursault/i;

function gameStyle({ typology, chars = [], appellation = '', title = '', price = 0, bottleSize = '0.75L' }) {
  const liters = parseFloat(bottleSize);
  if (!(liters >= 0.5 && liters <= 1)) return null;                    // fuori pool: mezze bottiglie (0.375) e magnum; 0.5L resta per i dolci
  const t = typology;
  if (t === 'champagne' || t === 'spumante') return 'bollicine';
  if (t === 'rose') return 'rosato';
  if (t === 'liquoroso' || t === 'dolce') return 'dolce';
  if (t === 'orange-wine') return 'orange';
  if (t !== 'bianco' && t !== 'rosso') return null;                    // distillati, bundle, no-low…
  if (chars.includes('dolce') && !chars.includes('secco')) return 'dolce'; // Auslese, vendemmie tardive

  let s = 0;
  for (const c of chars) s += (STRUCT[c] || 0) + (LIGHT[c] || 0);
  if (BIG.test(`${appellation} ${title}`)) s += 4;
  s += price >= 50 ? 2 : price >= 30 ? 1.5 : price <= 15 ? -0.5 : 0;
  return `${t}_${s >= 1.5 ? 'strutturato' : 'leggero'}`;
}

// "91pt" -> 91 (custom.tannico_rating)
const tannicoRating = (v) => parseInt(v, 10) || 0;


function toWine(it){
  if(!it.ok) return null;
  const style=gameStyle({typology:it.typ,chars:it.ch||[],appellation:it.app||'',title:it.t,price:+it.price,bottleSize:it.bs||''});
  if(!style) return null;
  const aw=(it.aw||[]).filter(a=>a&&a.n);
  return {name:it.t, tip:(it.typ||'').replace(/^./,c=>c.toUpperCase()), style, price:+it.price, giud:tannicoRating(it.r),
    region:it.reg||'', premi:aw.map(a=>`${a.n} ${a.pt}`), bestPt:Math.max(0,...aw.map(a=>+a.pt||0)), nPremi:aw.length,
    link:ROOT_URL+'products/'+it.h, vid:it.vid};
}
// una richiesta alla section dati, con tempo massimo: meglio un errore chiaro che "Carico i vini…" all'infinito
async function fetchPage(page){
  const ctl=new AbortController(), timer=setTimeout(()=>ctl.abort(),15000);
  try{
    const res=await fetch(`${POOL_URL}&page=${page}${THEME_QS}`,{credentials:'same-origin',signal:ctl.signal});
    if(!res.ok) throw new Error('pool HTTP '+res.status+' su '+res.url);
    const txt=await res.text(), at=txt.indexOf('{"page":');   // il div della section può avere attributi con graffe (anteprima/editor)
    if(at<0) throw new Error('pool: la risposta non contiene i dati del gioco (section gioco-a-tavola-dati assente in questo tema?) · '+txt.slice(0,160));
    const raw=txt.slice(at,txt.lastIndexOf('}')+1);
    try{ return JSON.parse(raw).items; }
    catch(e){ const p=+(String(e.message).match(/position (\d+)/)||[])[1]||0; throw new Error('pool: dati non validi ('+e.message+') vicino a: '+raw.slice(Math.max(0,p-80),p+40)); }
  }catch(e){ throw e.name==='AbortError'?new Error('pool: nessuna risposta in 15s (pagina '+page+')'):e; }
  finally{ clearTimeout(timer); }
}
// La collezione è ordinata per data di creazione e i prodotti sono stati caricati a blocchi per tipologia:
// una pagina sola è quasi tutta dello stesso stile. Si leggono 3 pagine distanti, in parallelo, e si bilancia.
const PAGES_READ=3, MAX_PER_STYLE=50;
async function loadPool(){
  const pages=Math.max(1,Math.ceil(POOL_COUNT/250));
  const d=new Date(), first=(d.getFullYear()*12+d.getMonth())%pages;   // stesse pagine per tutti nel mese
  const list=[...new Set([...Array(Math.min(PAGES_READ,pages)).keys()].map(k=>(first+Math.floor(k*pages/PAGES_READ))%pages+1))];
  const got=await Promise.allSettled(list.map(fetchPage));
  const ok=got.filter(g=>g.status==='fulfilled').map(g=>g.value);
  if(!ok.length) throw got[0].reason;                                  // nessuna pagina arrivata: errore vero
  const byName=new Map(), count={};
  for(let i=0;i<Math.max(...ok.map(p=>p.length));i++) for(const p of ok){   // a turno tra le pagine: nessuna domina
    const w=p[i]&&toWine(p[i]);
    if(!w||byName.has(w.name)||(count[w.style]||0)>=MAX_PER_STYLE) continue;
    byName.set(w.name,w); count[w.style]=(count[w.style]||0)+1;
  }
  return [...byName.values()];
}
async function initPool(){
  const btns=[...ROOT.querySelectorAll('#screen-home button')];
  btns.forEach(b=>b.disabled=true);
  $('poolPill').textContent='Carico i vini…';
  try{
    WINES=await loadPool();
    if(!WINES.length) throw new Error('pool vuoto');
    $('poolPill').textContent=`${WINES.length} vini reali Tannico`;
    btns.forEach(b=>b.disabled=false);
  }catch(e){
    console.error('[Tannico a Tavola]',e);
    $('poolPill').textContent='Vini non disponibili, riprova più tardi';
    $('poolPill').title=String(e&&e.message||e);   // diagnosi al passaggio del mouse
    track('pool_error',{error:String(e&&e.message||e)});
  }
}

let WINES = [];

/* ---------- pairing model ---------- */
const STYLE_LABEL = {
  bollicine:'Bollicine', bianco_leggero:'Bianco fresco', bianco_strutturato:'Bianco strutturato',
  rosato:'Rosato', rosso_leggero:'Rosso leggero', rosso_strutturato:'Rosso strutturato',
  dolce:'Dolce', orange:'Orange wine'
};
const STYLE_COLOR = {
  bollicine:'#e8d9a0', bianco_leggero:'#e6e2a8', bianco_strutturato:'#d8c46a',
  rosato:'#e79ab0', rosso_leggero:'#b5324f', rosso_strutturato:'#7a1330',
  dolce:'#c98a3a', orange:'#d97b2e'
};
// similarity of a wine style to an ideal course style (0..1)
const SIM = {
  bollicine:        {bollicine:1, bianco_leggero:.55, bianco_strutturato:.45, rosato:.5, rosso_leggero:.2, rosso_strutturato:.05, dolce:.3, orange:.35},
  bianco_leggero:   {bollicine:.6, bianco_leggero:1, bianco_strutturato:.7, rosato:.55, rosso_leggero:.2, rosso_strutturato:.05, dolce:.2, orange:.45},
  bianco_strutturato:{bollicine:.45, bianco_leggero:.7, bianco_strutturato:1, rosato:.5, rosso_leggero:.4, rosso_strutturato:.2, dolce:.3, orange:.6},
  rosato:           {bollicine:.55, bianco_leggero:.6, bianco_strutturato:.5, rosato:1, rosso_leggero:.55, rosso_strutturato:.2, dolce:.25, orange:.55},
  rosso_leggero:    {bollicine:.2, bianco_leggero:.25, bianco_strutturato:.4, rosato:.55, rosso_leggero:1, rosso_strutturato:.7, dolce:.15, orange:.5},
  rosso_strutturato:{bollicine:.05, bianco_leggero:.05, bianco_strutturato:.2, rosato:.2, rosso_leggero:.65, rosso_strutturato:1, dolce:.1, orange:.35},
  dolce:            {bollicine:.4, bianco_leggero:.2, bianco_strutturato:.25, rosato:.25, rosso_leggero:.15, rosso_strutturato:.1, dolce:1, orange:.3},
  orange:           {bollicine:.35, bianco_leggero:.45, bianco_strutturato:.6, rosato:.55, rosso_leggero:.5, rosso_strutturato:.35, dolce:.25, orange:1}
};

const OCCASIONS = [
  {id:'romantica', em:'🕯️', name:'Cena romantica', sub:'Eleganza, finezza, lume di candela',
    courses:[{em:'🦪',lab:'Apertura',dish:'Ostriche su ghiaccio',want:'bollicine'},
             {em:'🐟',lab:'Secondo',dish:'Branzino in crosta di sale',want:'bianco_strutturato'},
             {em:'🍫',lab:'Dolce',dish:'Tortino al cioccolato fondente',want:'dolce'}]},
  {id:'lavoro', em:'💼', name:'Cena di lavoro', sub:'Ospiti importanti: serve fare bella figura',
    courses:[{em:'🥂',lab:'Benvenuto',dish:'Culatello di Zibello',want:'bollicine'},
             {em:'🍚',lab:'Primo',dish:'Risotto allo zafferano',want:'bianco_strutturato'},
             {em:'🥩',lab:'Secondo',dish:'Brasato di manzo',want:'rosso_strutturato'}]},
  {id:'amici', em:'🎉', name:'Festa tra amici', sub:'Niente fronzoli, tanta sostanza',
    courses:[{em:'🧀',lab:'Sfizio',dish:'Tagliere e focaccia',want:'rosso_leggero'},
             {em:'🍔',lab:'Piatto',dish:'Hamburger gourmet',want:'rosso_leggero'},
             {em:'🔥',lab:'Gran finale',dish:'Grigliata mista',want:'rosso_strutturato'}]},
  {id:'pesce', em:'🐟', name:'Cena di pesce', sub:'Mare, freschezza, sapidità',
    courses:[{em:'🦐',lab:'Crudo',dish:'Crudo di gamberi e scampi',want:'bollicine'},
             {em:'🍝',lab:'Primo',dish:'Spaghetti alle vongole',want:'bianco_leggero'},
             {em:'🐠',lab:'Secondo',dish:'Grigliata di pesce',want:'bianco_strutturato'}]},
  {id:'aperitivo', em:'🍸', name:'Aperitivo con stuzzichini', sub:'Sfizioso, beverino, conviviale',
    courses:[{em:'🍤',lab:'Fritto',dish:'Fritto misto di mare',want:'bollicine'},
             {em:'🥓',lab:'Salumi',dish:'Tagliere di salumi',want:'rosato'},
             {em:'🫒',lab:'Tapas',dish:'Tapas e olive',want:'bianco_leggero'}]},
  {id:'famiglia', em:'🍝', name:'Pranzo della domenica', sub:'Tradizione, sapori pieni, casa',
    courses:[{em:'🍲',lab:'Primo',dish:'Lasagne al ragù',want:'rosso_strutturato'},
             {em:'🍖',lab:'Secondo',dish:'Arrosto della domenica',want:'rosso_strutturato'},
             {em:'🥧',lab:'Dolce',dish:'Crostata della nonna',want:'dolce'}]},
  {id:'montagna', em:'⛰️', name:'Weekend in montagna', sub:'Rifugio, freddo, sapori decisi',
    courses:[{em:'🧀',lab:'Antipasto',dish:'Speck e formaggi di malga',want:'bianco_strutturato'},
             {em:'🦌',lab:'Piatto',dish:'Capriolo in salmì',want:'rosso_strutturato'},
             {em:'🥮',lab:'Dolce',dish:'Strudel di mele',want:'dolce'}]},
  {id:'sushi', em:'🍣', name:'Serata sushi', sub:'Fresco, delicato, un po’ esotico',
    courses:[{em:'🍣',lab:'Nigiri',dish:'Selezione di nigiri',want:'bianco_leggero'},
             {em:'🥟',lab:'Piatto',dish:'Gyoza al vapore',want:'bollicine'},
             {em:'🌶️',lab:'Piccante',dish:'Tartare piccante di tonno',want:'orange'}]},
  {id:'giardino', em:'🌿', name:'Cena in giardino', sub:'Estate, leggerezza, convivialità',
    courses:[{em:'🍅',lab:'Antipasto',dish:'Caprese di bufala',want:'bianco_leggero'},
             {em:'🍗',lab:'Piatto',dish:'Pollo alla griglia alle erbe',want:'rosato'},
             {em:'🍉',lab:'Fine pasto',dish:'Coppa di frutta fresca',want:'bollicine'}]},
  {id:'vegetariana', em:'🥗', name:'Cena vegetariana', sub:'Orto, stagione, colori',
    courses:[{em:'🍄',lab:'Antipasto',dish:'Tartare di funghi porcini',want:'orange'},
             {em:'🎃',lab:'Primo',dish:'Risotto alla zucca',want:'bianco_strutturato'},
             {em:'🍰',lab:'Dolce',dish:'Cheesecake ai frutti di bosco',want:'dolce'}]},
  // ---- occasioni TRICKY: abbinamenti da vero sommelier, dove l'istinto porta fuori strada ----
  {id:'piccante', em:'🌶️', name:'Cena piccante', sub:'Spezie e peperoncino: qui l’istinto sbaglia',
    courses:[{em:'🍛',lab:'Curry',dish:'Curry rosso thailandese',want:'bianco_leggero'},
             {em:'🌮',lab:'Tacos',dish:'Tacos al pastore piccanti',want:'rosato'},
             {em:'🥭',lab:'Insalata',dish:'Insalata di mango e peperoncino',want:'dolce'}]},
  {id:'affumicato', em:'🔥', name:'Aperitivo affumicato', sub:'Legna e brace: occhio alle trappole',
    courses:[{em:'🐟',lab:'Salmone',dish:'Salmone affumicato',want:'bianco_strutturato'},
             {em:'🧀',lab:'Formaggio',dish:'Formaggio affumicato',want:'rosso_leggero'},
             {em:'🥓',lab:'Pancetta',dish:'Pancetta croccante',want:'bollicine'}]},
  {id:'formaggi', em:'🧈', name:'Serata di formaggi', sub:'Il tagliere che spiazza anche i sommelier',
    courses:[{em:'🍯',lab:'Erborinato',dish:'Gorgonzola e miele',want:'dolce'},
             {em:'🌰',lab:'Stagionati',dish:'Tagliere di stagionati e noci',want:'rosso_strutturato'},
             {em:'🍐',lab:'Pere',dish:'Pere caramellate con pecorino',want:'dolce'}]},
  {id:'tartufo', em:'🍄', name:'Cena al tartufo', sub:'Il profumo più prezioso: pensaci due volte',
    courses:[{em:'🥚',lab:'Uovo',dish:'Uovo al tartufo',want:'bianco_strutturato'},
             {em:'🍝',lab:'Tagliolini',dish:'Tagliolini al tartufo nero',want:'rosso_leggero'},
             {em:'🥩',lab:'Filetto',dish:'Filetto al tartufo',want:'rosso_strutturato'}]},
];

// moltiplicatore di "generosità" del budget per occasione (il budget vero è dinamico, vedi buildPlay)
const OCC_MULT = {romantica:1.08, lavoro:1.28, amici:0.86, pesce:1.0, aperitivo:0.86, famiglia:1.0,
  montagna:1.0, sushi:0.9, giardino:0.86, vegetariana:0.9, piccante:0.86, affumicato:0.9, formaggi:1.05, tartufo:1.25};
// tetto di prezzo per singolo vino in mano (evita outlier che gonfierebbero il budget)
const PRICE_CEIL = {romantica:90, lavoro:250, amici:48, pesce:75, aperitivo:45, famiglia:65,
  montagna:70, sushi:60, giardino:50, vegetariana:55, piccante:45, affumicato:55, formaggi:75, tartufo:140};

/* ---------- scoring ---------- */
const W_A=60, W_C=25, W_B=15; // Abbinamento domina; Tannico 2° asse; Premi solo bonus leggero
// PREMI (0..1): bonus per la critica internazionale (Parker, Suckling, WS, Decanter, Gambero Rosso…).
// Pesa poco (max 15) quindi non è un outlier che decide la partita: è il "di più" da raccontare/upsell.
function premiScore(w){
  const q = w.bestPt>0 ? Math.max(0,Math.min(1,(w.bestPt-86)/12)) : 0;    // qualità del miglior punteggio 100-scale
  const n = Math.min(w.nPremi,5)/5;                                       // quante riconoscimenti
  return q*0.72 + n*0.28;
}
function tannicoScore(w){ return Math.max(0,Math.min(1,(w.giud-85)/11)); }
function abbinaScore(wineStyle, courseWant){ return SIM[wineStyle][courseWant]; }
// se l'abbinamento è sbagliato, premi e tannico contano molto meno: un trofeo mal abbinato non deve vincere
function fitFactor(a){ return a>=0.65 ? 1 : a>=0.4 ? 0.5 : 0.15; }

// optimal assignment of 3 bottles to 3 courses -> {perm, total abbina(0..1 avg), per}
const PERMS=[[0,1,2],[0,2,1],[1,0,2],[1,2,0],[2,0,1],[2,1,0]];
function bestAssign(bottles, courses){
  let best=null;
  for(const p of PERMS){
    let sum=0, per=[];
    for(let i=0;i<3;i++){ const a=abbinaScore(bottles[i].style, courses[p[i]].want); sum+=a; per[i]={courseIdx:p[i],a}; }
    if(!best||sum>best.sum) best={sum,per,perm:p};
  }
  return best;
}
function lineupScore(bottles, courses){
  const asg=bestAssign(bottles,courses);
  let total=0, detail=[];
  for(let i=0;i<3;i++){
    const w=bottles[i]; const a=asg.per[i].a, b=premiScore(w), c=tannicoScore(w);
    const pts=a*W_A + (b*W_B + c*W_C)*fitFactor(a);
    total+=pts;
    detail.push({wine:w, courseIdx:asg.per[i].courseIdx, a,b,c, pts});
  }
  return {total, detail};
}

/* ---------- game state ---------- */
let occ=null, hand=[], selected=[], occBudget=0, lastResult=null;
let MODE='free';        // 'free' | 'daily'
let RND=Math.random;    // sorgente di casualità (seedata in modalità daily)
let dayKey='';
let activeSlot=0;       // portata "attiva" su cui finisce il prossimo vino scelto
let busy=false;         // guard anti doppio-avvio / click durante lo spin
let spinTimer=null, heroTimer=null;     // timeout dello spin (per poterlo saltare)
let hintOn=false;       // mostra l'abbinamento consigliato (aiuto novizi)
let hintCourse=-1;      // QUALE portata è stata aiutata (solo quella attiva al momento dell'uso)
let rerollsLeft=0;      // 1 reroll gratuito della mano per partita (agency pre-decisione)
const HINT_COST=15;     // l'aiuto ora COSTA punti: è una vera decisione, non un freebie
const COMBO_BONUS_PCT=0.20; // tris perfetto (3/3 abbinamento) → bonus non lineare
const spentNow=()=>selected.reduce((s,i)=>s+(i!=null?hand[i].price:0),0);

// PRNG deterministico (mulberry32)
function mulberry32(a){return function(){a|=0;a=a+0x6D2B79F5|0;let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}
function todayKey(){const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`}
function seedFromKey(k){let h=2166136261;for(let i=0;i<k.length;i++){h^=k.charCodeAt(i);h=Math.imul(h,16777619)}return h>>>0}

function $(id){return document.getElementById(id)}
const SCREENS=['screen-home','screen-spin','screen-play','screen-result','screen-hero','screen-heroover'];
function show(id){
  SCREENS.forEach(s=>$(s).classList.add('hidden'));
  $(id).classList.remove('hidden');$(id).classList.add('fade');window.scrollTo(0,0);
  // pulsante Esci visibile durante una gara in corso (non in home né nei riepiloghi)
  const inGame = (id==='screen-play'||id==='screen-spin'||id==='screen-hero');
  $('exitBtn').classList.toggle('hidden', !inGame);
  $('poolPill').classList.toggle('hidden', inGame);
}
function goHome(){ clearTimeout(spinTimer); clearTimeout(heroTimer); busy=false; MODE='free'; $('actionbar').classList.add('hidden'); show('screen-home'); updateDailyInfo(); updateHeroHome(); renderCareerPanel(); }
/* ---- statistiche di carriera: persistono oltre la singola partita/streak ---- */
function careerStats(){ let s; try{s=JSON.parse(localStorage.getItem('tannico_career')||'{}')}catch(e){s={}} return {games:s.games||0, perfectCourses:s.perfectCourses||0, totalCourses:s.totalCourses||0, styleCounts:s.styleCounts||{}, bestScoreEver:s.bestScoreEver||0}; }
function recordCareer(detail, scoreTotal){
  const s=careerStats();
  s.games++; s.totalCourses+=3;
  detail.forEach(d=>{ if(d.a>=0.85) s.perfectCourses++; s.styleCounts[d.wine.style]=(s.styleCounts[d.wine.style]||0)+1; });
  s.bestScoreEver=Math.max(s.bestScoreEver, scoreTotal);
  try{localStorage.setItem('tannico_career',JSON.stringify(s))}catch(e){}
}
function renderCareerPanel(){
  const s=careerStats(); const el=$('careerPanel'); if(!el) return;
  if(s.games===0){ el.innerHTML=`<div class="career-teaser">Gioca la tua prima partita per sbloccare le statistiche 📊</div>`; return; }
  const pct = s.totalCourses ? Math.round(s.perfectCourses/s.totalCourses*100) : 0;
  let favStyle='—', favN=0;
  Object.entries(s.styleCounts).forEach(([k,v])=>{ if(v>favN){favN=v;favStyle=STYLE_LABEL[k]||k;} });
  const hb=heroStats().best;
  el.innerHTML=`<h3>📊 Le tue statistiche</h3><div class="career-grid">
    <div class="career-stat"><b>${s.games}</b><span>partite</span></div>
    <div class="career-stat"><b>${pct}%</b><span>abbinamenti perfetti</span></div>
    <div class="career-stat"><b>${favStyle}</b><span>stile preferito</span></div>
    <div class="career-stat"><b>${s.bestScoreEver}</b><span>miglior punteggio</span></div>
    <div class="career-stat"><b>${hb}</b><span>record Maratona</span></div>
  </div>`;
}
function quitGame(){
  const inGame = !$('screen-play').classList.contains('hidden') || !$('screen-hero').classList.contains('hidden') || !$('screen-spin').classList.contains('hidden');
  if(inGame && !confirm('Vuoi uscire? La partita in corso andrà persa.')) return;
  goHome();
}
function toggleTheme(){
  const light = document.documentElement.getAttribute('data-theme')==='light';
  if(light){ document.documentElement.removeAttribute('data-theme'); try{localStorage.setItem('tannico_theme','dark')}catch(e){} }
  else{ document.documentElement.setAttribute('data-theme','light'); try{localStorage.setItem('tannico_theme','light')}catch(e){} }
}
function sample(arr,n){const a=[...arr];for(let i=a.length-1;i>0;i--){const j=Math.floor(RND()*(i+1));[a[i],a[j]]=[a[j],a[i]]}return a.slice(0,n)}

let glassUid=0;
function glassSVG(style,big){
  const col=STYLE_COLOR[style]; const h=big?64:54; const gid='g_'+style+'_'+(glassUid++);
  return `<svg width="${big?44:38}" height="${h}" viewBox="0 0 44 64"><defs><linearGradient id="${gid}" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="${col}" stop-opacity=".55"/><stop offset="1" stop-color="${col}"/></linearGradient></defs>
  <path class="go" d="M10 4 H34 V20 Q34 32 22 33 Q10 32 10 20 Z" fill="none" stroke-width="1.4"/>
  <path d="M11.5 13 H32.5 V20 Q32.5 30 22 31 Q11.5 30 11.5 20 Z" fill="url(#${gid})"/>
  <rect class="gf" x="21" y="33" width="2" height="20"/>
  <rect class="gf" x="13" y="55" width="18" height="3" rx="1.5"/></svg>`;
}

/* ---------- ENTRY ---------- */
// tracciamento PostHog: posthog.js lo carica il tema, solo con il consenso analytics; senza, non parte niente
function track(name, props={}){
  try{ if(window.posthog&&typeof window.posthog.capture==='function') window.posthog.capture('tannico_a_tavola_'+name,{...props,tracker:'posthog_js'}); }catch(e){}
}
const eur=n=>{const c=Math.round(n*100); return c%100 ? (c/100).toFixed(2).replace('.',',') : String(c/100);};
function startFree(){ if(busy)return; MODE='free'; RND=Math.random; startSpin(Math.floor(Math.random()*OCCASIONS.length)); }
function startDaily(){
  if(busy)return; MODE='daily'; dayKey=todayKey();
  RND=mulberry32(seedFromKey(dayKey));
  const target=Math.floor(RND()*OCCASIONS.length); // prima estrazione dal seed = occasione del giorno
  startSpin(target);
}

/* ---------- SPIN ---------- */
function startSpin(target){
  busy=true;                       // guard: niente avvii sovrapposti durante lo spin
  show('screen-spin');
  occ=OCCASIONS[target];
  const reel=$('reelInner'); reel.style.transition='none'; reel.style.transform='translateY(0)';
  const loops=5, seq=[];
  for(let l=0;l<loops;l++) for(const o of OCCASIONS) seq.push(o);
  // ensure it lands on target at a known index
  seq.push(...OCCASIONS.slice(0,target+1));
  reel.innerHTML=seq.map(o=>`<div class="reel-item"><div class="em">${o.em}</div><div class="nm">${o.name}</div></div>`).join('');
  const itemH=120, landIdx=seq.length-1;
  void reel.offsetWidth;
  requestAnimationFrame(()=>{ reel.style.transition='transform 3.4s cubic-bezier(.12,.7,.12,1)'; reel.style.transform=`translateY(${-(landIdx)*itemH}px)`; });
  clearTimeout(spinTimer); spinTimer=setTimeout(()=>buildPlay(), 3550);
}
function skipSpin(){ if($('screen-spin').classList.contains('hidden'))return; clearTimeout(spinTimer); buildPlay(); }

/* ---------- PLAY ---------- */
function updateOccBanner(){
  $('occBanner').innerHTML=`<div class="em">${occ.em}</div><div style="flex:1"><h2>${occ.name}</h2><div class="sub">${occ.sub}</div></div><div class="budget-chip"><span>spesa max</span><b>€${occBudget}</b></div>`;
}
// genera mano + budget (isolata dal resto di buildPlay così il reroll può richiamarla da sola)
function generateHandAndBudget(){
  // MANO sempre giocabile: per OGNI portata garantisci ≥2 vini forti (match perfetto) così il
  // punteggio massimo è sempre raggiungibile. Poi riempi con distrattori per mantenere la sfida.
  // Tutti i candidati restano sotto un tetto di prezzo per occasione (niente outlier).
  const ceil=PRICE_CEIL[occ.id]||90;
  const cap=arr=>arr.filter(w=>w.price<=ceil);
  hand=[]; const seen=new Set();
  const add=w=>{ if(w&&!seen.has(w.name)){seen.add(w.name);hand.push(w);return true} return false };
  for(const c of occ.courses){
    let strong=cap(WINES.filter(w=>w.style===c.want));                 // abbinamento perfetto (SIM=1) sotto il tetto
    if(strong.length<2) strong=WINES.filter(w=>w.style===c.want);      // fallback: qualunque prezzo
    if(strong.length<2) strong=cap(WINES.filter(w=>SIM[w.style][c.want]>=.7)); // fallback: buoni
    let added=0; for(const w of sample(strong, strong.length)){ if(added>=2)break; if(add(w))added++; }
  }
  // VINO FLEX: rende reale il puzzle di assegnazione. Cerca lo stile che sta bene su DUE
  // portate insieme (non solo una) e lo inserisce apposta — così scegliere quel vino significa
  // anche dover decidere su quale delle due portate schierarlo, invece di un'assegnazione ovvia.
  const wantList=occ.courses.map(c=>c.want);
  let bestFlexStyle=null, bestFlexScore=-1;
  for(const style of Object.keys(SIM)){
    for(let i=0;i<3;i++)for(let j=i+1;j<3;j++){
      const s=Math.min(SIM[style][wantList[i]], SIM[style][wantList[j]]);
      if(s>bestFlexScore){ bestFlexScore=s; bestFlexStyle=style; }
    }
  }
  if(bestFlexScore>=0.55){
    const flexWines=cap(WINES.filter(w=>w.style===bestFlexStyle));
    let addedFlex=0; for(const w of sample(flexWines, flexWines.length)){ if(addedFlex>=2)break; if(add(w))addedFlex++; }
  }
  // distrattori: qualche vino "a tema" (medio) + rumore puro, fino a 18 — sempre sotto il tetto
  const HAND_N=18;
  const wanted=new Set(wantList);
  const themed=cap(WINES.filter(w=>[...wanted].some(t=>SIM[w.style][t]>=.4)));
  for(const w of sample(themed, themed.length)){ if(hand.length>=12)break; add(w); }
  for(const w of sample(cap(WINES), cap(WINES).length)){ if(hand.length>=HAND_N)break; add(w); }
  for(const w of sample(WINES, WINES.length)){ if(hand.length>=HAND_N)break; add(w); } // ultima rete di sicurezza
  hand=sample(hand,HAND_N);   // mescola le posizioni
  // BUDGET DINAMICO: dalla distribuzione prezzi DELLA MANO → tensione costante.
  // Base = percentili 20/40/60 dei prezzi, modulata per occasione, MA SEMPRE ≥ vino più caro in mano
  // (così ogni singolo vino è acquistabile) e ≥ terna minima.
  const ps=hand.map(w=>w.price).sort((a,b)=>a-b);
  const n=ps.length; const q=f=>ps[Math.min(n-1,Math.floor(n*f))];
  const min3=ps[0]+ps[1]+ps[2];
  const maxSingle=ps[n-1];
  const base=q(0.2)+q(0.4)+q(0.6);
  let b=Math.max(base*(OCC_MULT[occ.id]||1), maxSingle, min3*1.05);
  occBudget=Math.round(b/5)*5;
  if(occBudget<maxSingle) occBudget=Math.ceil(maxSingle/5)*5;   // garanzia: nessun vino > budget
}
function buildPlay(){
  show('screen-play');
  $('actionbar').classList.remove('hidden');
  generateHandAndBudget();
  selected=[null,null,null];   // selected[courseIdx] = indice in hand (assegnazione per PORTATA)
  activeSlot=0; busy=false; hintOn=false; hintCourse=-1; rerollsLeft=1;
  const hb=$('hintBtn'); hb.classList.remove('used'); hb.disabled=false; hb.textContent=`💡 Aiutami (−${HINT_COST}pt)`;
  updateOccBanner();
  renderMenu();
  renderSlots(); renderHand();
  renderRerollBanner(true);
  track('start',{mode:MODE, occasion:occ.id, budget:occBudget});
}
function renderRerollBanner(showIt){
  const el=$('rerollBanner'); if(!el) return;
  if(!showIt){ el.classList.add('hidden'); return; }
  el.classList.remove('hidden');
  el.innerHTML=`<span>🎲 Spesa massima €${occBudget}: ti va questa mano?</span><div style="display:flex;gap:8px"><button class="rb-reroll" onclick="TannicoATavola.rerollHand()">Rimescola (1)</button><button class="rb-accept" onclick="TannicoATavola.acceptHand()">Gioca questa mano</button></div>`;
}
function rerollHand(){
  if(rerollsLeft<=0) return;
  rerollsLeft--;
  track('reroll',{mode:MODE, occasion:occ.id});
  generateHandAndBudget();
  selected=[null,null,null]; activeSlot=0;
  updateOccBanner();
  renderSlots(); renderHand();
  renderRerollBanner(false);
  toast('Nuova mano servita 🎲');
}
function acceptHand(){ renderRerollBanner(false); }
function useHint(){
  if(hintOn)return; hintOn=true;
  track('hint',{mode:MODE, occasion:occ.id});
  // aiuta SOLO la portata su cui sei ora (slot attivo se libero, altrimenti la prima ancora da abbinare)
  hintCourse = (selected[activeSlot]==null) ? activeSlot : selected.indexOf(null);
  if(hintCourse<0) hintCourse=activeSlot;   // tutte già abbinate: aiuta quella attiva
  renderMenu();
  const b=$('hintBtn'); b.classList.add('used'); b.disabled=true; b.textContent=`✓ Aiuto usato (−${HINT_COST}pt)`;
}
function renderMenu(){
  $('menu').innerHTML=occ.courses.map((c,ci)=>`<div class="course"><div class="em">${c.em}</div><div class="lab">${c.lab}</div><div class="dish">${c.dish}</div>${hintOn&&ci===hintCourse?`<div class="want">ci vuole: ${STYLE_LABEL[c.want]}</div>`:''}</div>`).join('');
}
function renderHand(){
  $('hand').innerHTML=hand.map((w,i)=>{
    const ci=selected.indexOf(i);   // a quale portata è assegnato
    return `<div class="bottle ${ci>-1?'sel':''}" onclick="TannicoATavola.toggle(${i})">
      ${ci>-1?`<div class="assigned-to">→ ${occ.courses[ci].lab}</div>`:`<div class="qmark"></div>`}
      <div class="bglass">${glassSVG(w.style)}</div>
      <div class="bn-name">${w.name}</div>
      <div class="styletag">${STYLE_LABEL[w.style]}</div>
      <div class="bn-meta"><span>${w.region||w.tip}</span><span class="pr">€${eur(w.price)}</span></div>
    </div>`;
  }).join('');
}
const TOUCH = !!(window.matchMedia && matchMedia('(pointer:coarse)').matches);
function selectSlot(ci){ activeSlot=ci; renderSlots(); }
function renderSlots(){
  const slots=occ.courses.map((c,ci)=>{
    const idx=selected[ci]; const isAct=ci===activeSlot; const act=isAct?' active':'';
    const addTxt = isAct ? (TOUCH?'tocca un vino qui sotto ↓':'scegli un vino qui sotto ↓') : '＋ scegli un vino';
    if(idx==null) return `<div class="slot${act}" onclick="TannicoATavola.selectSlot(${ci})"><div class="slot-course"><span class="sc-em">${c.em}</span><span class="sc-lab">${c.lab}</span></div><span class="sc-add${isAct?' on':''}">${addTxt}</span></div>`;
    const w=hand[idx];
    return `<div class="slot full${act}" onclick="TannicoATavola.selectSlot(${ci})"><div class="slot-course"><span class="sc-em">${c.em}</span><span class="sc-lab">${c.lab}</span></div>${glassSVG(w.style)}<div class="bn">${w.name}</div><span class="x" onclick="event.stopPropagation();TannicoATavola.clearSlot(${ci})">✕</span></div>`;
  }).join('');
  $('slots').innerHTML=slots;
  const nSel=selected.filter(x=>x!=null).length;
  $('slotCnt').textContent=`${nSel} / 3`;
  const full=nSel===3;
  const spent=spentNow();
  const over=spent>occBudget;
  const left=occBudget-spent;
  const pct=Math.min(100,spent/occBudget*100);
  $('budgetMeter').innerHTML=`<div class="bm-row"><span>Speso <b class="${over?'over':''}">€${eur(spent)}</b> / €${occBudget}</span><span class="${over?'over':left<occBudget*0.15?'tight':'ok'}">${over?'superato di €'+eur((spent-occBudget)):'restano €'+eur(left)}</span></div><div class="bm-bar"><i style="width:${pct}%;background:${over?'var(--bad)':'linear-gradient(90deg,var(--gold2),var(--gold))'}"></i></div>`;
  $('confirmBtn').disabled=!full||over;
  const manca=3-nSel;
  $('abLab').textContent = over ? '⚠️ Hai superato la spesa massima' : (full?'Selezione pronta: confermi?':`Scegli una portata, poi un vino · manca${manca===1?'':'no'} ${manca}`);
}
function clearSlot(ci){ selected[ci]=null; activeSlot=ci; renderSlots(); renderHand(); }
function toggle(i){
  const ci=selected.indexOf(i);
  if(ci>-1){ selected[ci]=null; activeSlot=ci; }                   // tocco un vino già assegnato → lo rimuovo
  else {
    // assegna allo slot ATTIVO se libero, altrimenti al primo libero
    let target = (selected[activeSlot]==null) ? activeSlot : selected.indexOf(null);
    if(target<0) target=activeSlot;                                // tutti pieni → sostituisci quello attivo
    selected[target]=i;
    const next=selected.indexOf(null); activeSlot = next<0 ? target : next;  // porta il focus alla prossima portata libera
    sndPop();
  }
  renderSlots(); renderHand();
}

/* ---------- REVEAL ---------- */
function fitClass(a){return a>=.8?'fit-good':a>=.5?'fit-mid':'fit-bad'}
function fitLabel(a){return a>=.85?'Abbinamento perfetto':a>=.65?'Buon abbinamento':a>=.4?'Abbinamento incerto':'Fuori posto'}
// punteggio con l'abbinamento SCELTO dal giocatore (vino → portata fissa)
function scoreFixed(assign){
  let total=0, detail=[];
  for(let ci=0;ci<3;ci++){
    const w=hand[assign[ci]];
    const a=abbinaScore(w.style, occ.courses[ci].want), b=premiScore(w), c=tannicoScore(w);
    const pts=a*W_A+(b*W_B+c*W_C)*fitFactor(a); total+=pts;
    detail.push({wine:w, courseIdx:ci, a,b,c, pts});
  }
  return {total, detail};
}
function reveal(){
  const res=scoreFixed(selected);
  const spent=spentNow();
  // optimal over the hand — ENTRO il budget (è qui la bravura). Il bonus tris-perfetto è incluso
  // già nella ricerca, così il "par" è davvero il tetto massimo raggiungibile (bonus compreso).
  let bestCombo=null; const N=hand.length;
  for(let i=0;i<N;i++)for(let j=i+1;j<N;j++)for(let k=j+1;k<N;k++){
    if(hand[i].price+hand[j].price+hand[k].price>occBudget) continue;
    const r=lineupScore([hand[i],hand[j],hand[k]],occ.courses);
    let rTotal=r.total;
    if(r.detail.every(d=>d.a>=0.85)) rTotal*=(1+COMBO_BONUS_PCT);
    if(!bestCombo||rTotal>bestCombo.total) bestCombo={total:rTotal,idx:[i,j,k],detail:r.detail,cost:hand[i].price+hand[j].price+hand[k].price};
  }
  show('screen-result');
  $('actionbar').classList.add('hidden');
  // BONUS COMBO: tris perfetto (3/3 abbinamento) premia in modo non lineare, non solo additivo
  const allPerfect = res.detail.every(d=>d.a>=0.85);
  const comboBonus = allPerfect ? Math.round(res.total*COMBO_BONUS_PCT) : 0;
  res.total += comboBonus;
  // AIUTO A PAGAMENTO: se usato, costa punti veri — non è più un freebie
  const hintPenalty = hintOn ? HINT_COST : 0;
  res.total = Math.max(0, res.total - hintPenalty);
  // il "massimo" è il punteggio realistico = la lineup migliore possibile in questa mano (par), non 300
  const par=Math.round(bestCombo.total);
  const eff=res.total/bestCombo.total;
  // rank ricalibrato e più severo: serve avvicinarsi DAVVERO al par
  let rank,col;
  if(eff>=.97){rank='🏆 Sommelier leggendario';col='#f1d9a4'}
  else if(eff>=.90){rank='🥇 Maestro sommelier';col='#eed9a8'}
  else if(eff>=.82){rank='🥈 Sommelier esperto';col='#dfe3ec'}
  else if(eff>=.70){rank='🥉 Buon intenditore';col='#ecd0b4'}
  else if(eff>=.55){rank='🍷 Apprendista';col='#f0d6dc'}
  else {rank='🫤 Tappo';col='#e3e6ee'}
  const badge=$('rankBadge'); badge.textContent=rank; badge.style.background=col; badge.style.color='#141a33';
  $('scoreBig').innerHTML=`<span id="scoreNum">0</span><small> / ${par} pt</small>`;
  countUp($('scoreNum'), Math.round(res.total), 900);
  $('eff').innerHTML=`<b class="gold">${Math.round(eff*100)}%</b> del punteggio massimo possibile con questa mano &nbsp;·&nbsp; spesi <b class="gold">€${eur(spent)}</b> su €${occBudget}`;
  const bonusMsgs=[];
  if(allPerfect) bonusMsgs.push(`🎉 Tris perfetto! Bonus +${comboBonus}pt`);
  if(hintOn) bonusMsgs.push(`💡 Aiuto usato: −${HINT_COST}pt`);
  $('bonusLine').innerHTML = bonusMsgs.join(' &nbsp;·&nbsp; ');
  if(allPerfect){ launchConfetti(); sndPerfect(); }

  $('resCards').innerHTML=res.detail.map(d=>{
    const c=occ.courses[d.courseIdx]; const w=d.wine; const ff=fitFactor(d.a);
    const A=Math.round(d.a*W_A),B=Math.round(d.b*W_B*ff),C=Math.round(d.c*W_C*ff);
    const premiTxt=w.premi&&w.premi.length?w.premi.join(' · '):'nessun premio';
    const lost = Math.round((d.b*W_B + d.c*W_C)*(1-ff));
    const penal = ff<1 ? `<div class="penalty">⚠️ ${ff<=0.15?'Abbinamento sconsigliato: premi e giudizio quasi non contano':'Abbinamento incerto: premi e giudizio valgono la metà'}${lost>0?` (−${lost} ${lost===1?'punto':'punti'})`:''}</div>` : '';
    return `<div class="rc">
      <div class="course-tag">${c.em} ${c.dish}</div>
      <a class="rn" href="${w.link}" target="_blank" rel="noopener" data-course="${c.lab}">${w.name} ↗</a>
      <div class="rmeta">${w.region||w.tip} · €${eur(w.price)} · <span class="${fitClass(d.a)}">${fitLabel(d.a)}</span></div>
      <div class="statline"><span class="k">Abbinamento</span><div class="bar"><i style="width:${d.a*100}%;background:var(--A)"></i></div><span class="v">${A}</span></div>
      <div class="statline"><span class="k">Premi</span><div class="bar"><i style="width:${d.b*ff*100}%;background:var(--B)"></i></div><span class="v">${B}</span></div>
      <div class="statline"><span class="k">Giudizio</span><div class="bar"><i style="width:${d.c*ff*100}%;background:var(--C)"></i></div><span class="v">${C}</span></div>
      ${penal}
      <div class="pts">Giudizio Tannico <b>${w.giud}pt</b> · ${premiTxt}</div>
      <div class="tot">${Math.round(d.pts)} pt</div>
    </div>`;
  }).join('');

  const perfect = Math.round(res.total) >= Math.round(bestCombo.total);
  $('optimal').innerHTML=`<h3>${perfect?'✅ Hai trovato la selezione migliore possibile!':`La selezione migliore entro €${occBudget}`}</h3>`+
    bestCombo.detail.map(d=>{const c=occ.courses[d.courseIdx];return `<div class="opt-row"><span class="on">${c.em} <b>${c.dish.split(' ').slice(0,3).join(' ')}</b> → ${d.wine.name} <span class="muted">€${eur(d.wine.price)}</span></span><span class="ov">${Math.round(d.pts)}pt</span></div>`}).join('')+
    `<div class="opt-row"><span class="on muted">Totale massimo · spesa €${eur(bestCombo.cost)}</span><span class="ov">${Math.round(bestCombo.total)}pt</span></div>`;

  lastResult={bottles:res.detail.map(d=>d.wine), detail:res.detail, total:Math.round(res.total), eff:Math.round(eff*100), rank, rankCol:col, spent:Math.round(spent*100)/100, occName:occ.name, occEm:occ.em, budget:occBudget, par:Math.round(bestCombo.total), daily:MODE==='daily', dayKey};
  recordCareer(res.detail, Math.round(res.total));
  track('result',{mode:MODE, occasion:occ.id, score:lastResult.total, par:lastResult.par, pct:lastResult.eff, rank:rank.replace(/^\S+\s/,''),
    spent:lastResult.spent, budget:occBudget, perfect:allPerfect, hint_used:hintOn, rerolled:rerollsLeft===0, best_found:perfect});

  // ---- modalità Sfida del giorno ----
  const dt=$('dailyTag'), ds=$('dailyStreak');
  if(MODE==='daily'){
    const rec=recordDaily(lastResult.total);
    dt.classList.remove('hidden'); ds.classList.remove('hidden');
    dt.textContent=`🎯 SFIDA DEL GIORNO · ${dayKey.split('-').reverse().join('/')}`;
    const pb = rec.best>lastResult.total ? ` · primato di oggi ${rec.best}pt` : '';
    ds.innerHTML=`Massimo di oggi <b class="gold">${lastResult.par}pt</b> &nbsp;·&nbsp; serie 🔥 <b class="gold">${rec.streak}</b> ${rec.streak===1?'giorno':'giorni'}${pb}`;
  } else { dt.classList.add('hidden'); ds.classList.add('hidden'); }
}

/* ---------- daily storage (no backend: best/streak locali, mano identica per tutti) ---------- */
function recordDaily(score){
  let st; try{st=JSON.parse(localStorage.getItem('tannico_lineup')||'{}')}catch(e){st={}}
  const days=st.days||{}; const prevBest=days[dayKey]||0;
  // streak: +1 se l'ultimo giorno giocato è ieri; resta se è oggi; reset altrimenti
  if(st.lastDay!==dayKey){
    const y=new Date(); y.setDate(y.getDate()-1);
    const yKey=`${y.getFullYear()}-${String(y.getMonth()+1).padStart(2,'0')}-${String(y.getDate()).padStart(2,'0')}`;
    st.streak = (st.lastDay===yKey) ? (st.streak||0)+1 : 1;
    st.lastDay=dayKey;
  }
  days[dayKey]=Math.max(prevBest,score); st.days=days;
  try{localStorage.setItem('tannico_lineup',JSON.stringify(st))}catch(e){}
  return {best:Math.max(prevBest,score), streak:st.streak||1};
}
function updateDailyInfo(){
  let st; try{st=JSON.parse(localStorage.getItem('tannico_lineup')||'{}')}catch(e){st={}}
  const k=todayKey(); const played=st.days&&st.days[k];
  const el=$('dailyInfo'); if(!el) return;
  if(played) el.innerHTML=`✅ Sfida di oggi giocata — primato <b class="gold">${st.days[k]}pt</b> &nbsp;·&nbsp; serie 🔥 ${st.streak||1}`;
  else if(st.streak) el.innerHTML=`🔥 Serie attiva: <b class="gold">${st.streak}</b> ${st.streak===1?'giorno':'giorni'} — non perdere la sfida di oggi!`;
  else el.innerHTML=`Una nuova occasione e una nuova mano <b>ogni giorno</b>, uguali per tutti.`;
}

/* ---------- ACQUISTA + CONDIVIDI ---------- */
function toast(msg){let t=$('toast');if(!t){t=document.createElement('div');t.id='toast';ROOT.appendChild(t)}t.textContent=msg;t.className='show';clearTimeout(window._tt);window._tt=setTimeout(()=>t.className='',2200)}
// carrello del tema: stessi eventi standard Shopify usati da src/integrations/search.js (Doofinder)
let buying=false;   // doppio clic su Acquista = una sola aggiunta
async function buyLineup(){
  if(buying) return; buying=true;
  const ids=lastResult.bottles.map(w=>w.vid);
  const { CartLinesUpdateEvent, CartErrorEvent } = await import('https://cdn.shopify.com/storefront/standard-events.js');
  const deferred=CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'tannico-a-tavola',
    lines:ids.map(id=>({merchandiseId:String(id),quantity:1})),promise:deferred.promise}));
  try{
    const res=await fetch(ROOT_URL+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:ids.map(id=>({id,quantity:1}))})});
    const data=await res.json();
    if(!res.ok) throw new Error(data.description||data.message||'Aggiunta al carrello non riuscita');
    const cart=await fetch(ROOT_URL+'cart.js').then(r=>r.json());
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart)});
    track('add_to_cart',{mode:MODE, occasion:occ.id, via:'ajax', variant_ids:ids, value:lastResult.spent, currency:'EUR', score:lastResult.total});
    setTimeout(()=>document.dispatchEvent(new CustomEvent('sidecart:open')),200);
    toast('Selezione aggiunta al carrello 🍷');
  }catch(e){
    deferred.reject(e);
    document.dispatchEvent(new CartErrorEvent({error:e.message,code:'INVALID'}));
    track('add_to_cart_error',{mode:MODE, occasion:occ.id, error:e.message});
    toast(e.message);
  }finally{ buying=false; }
}
function shareText(){
  const r=lastResult;
  const head = r.daily
    ? `🍷 Tannico a Tavola — 🎯 Sfida del giorno ${r.dayKey.split('-').reverse().join('/')} (${r.occEm} ${r.occName})\n${r.total} pt sul massimo di ${r.par} (${r.rank}), spesi €${eur(r.spent)}/${r.budget}.`
    : `🍷 Tannico a Tavola — ${r.occEm} ${r.occName}\nHo totalizzato ${r.total}/${r.par} pt (${r.rank}) spendendo €${eur(r.spent)}/${r.budget}.`;
  return head+`\nLa mia selezione:\n`+
    r.detail.map(d=>`• ${d.wine.name} (${Math.round(d.pts)}pt)`).join('\n')+
    (r.daily?`\nStessa mano per tutti oggi — battimi!`:`\nBatti il mio punteggio!`);
}
const SHARE_URL=location.origin+location.pathname;
document.addEventListener('click',e=>{const a=e.target.closest&&e.target.closest('#resCards a.rn'); if(a) track('product_click',{mode:MODE, occasion:occ&&occ.id, course:a.dataset.course, product:a.getAttribute('href').split('?')[0].split('/').pop()});});
function shareResult(){
  track('share_open',{mode:MODE, occasion:occ.id, score:lastResult.total});
  // card-immagine nel modale (stile 82-0)
  try{ $('shareImg').src=buildShareCanvas().toDataURL('image/png'); }catch(e){}
  $('shareSnippet').textContent=shareText().split('\n')[0]+' '+shareText().split('\n').slice(-1)[0];
  $('shareModal').classList.remove('hidden');
}
function closeShare(){ $('shareModal').classList.add('hidden'); }
function shareTo(net){
  track('share',{network:net, mode:MODE, occasion:occ.id});
  const txt=shareText(), u=SHARE_URL, et=encodeURIComponent(txt), eu=encodeURIComponent(u);
  let url='';
  if(net==='x') url=`https://twitter.com/intent/tweet?text=${et}&url=${eu}`;
  else if(net==='whatsapp') url=`https://wa.me/?text=${encodeURIComponent(txt+'\n'+u)}`;
  else if(net==='telegram') url=`https://t.me/share/url?url=${eu}&text=${et}`;
  else if(net==='facebook') url=`https://www.facebook.com/sharer/sharer.php?u=${eu}&quote=${et}`;
  else if(net==='reddit') url=`https://www.reddit.com/submit?title=${encodeURIComponent('Tannico a Tavola — '+lastResult.total+'/'+lastResult.par+'pt')}&url=${eu}`;
  else if(net==='copy'){ navigator.clipboard.writeText(txt+'\n'+u).then(()=>toast('Testo copiato ✓'),()=>toast('Copia non riuscita')); return; }
  // su mobile, se disponibile, prova la condivisione nativa (allega anche l'immagine se possibile)
  window.open(url,'_blank','noopener');
}
function buildShareCanvas(){
  const r=lastResult, W=1080, H=1350, cv=document.createElement('canvas');cv.width=W;cv.height=H;const x=cv.getContext('2d');
  const F='Helvetica Neue,Helvetica,Arial,sans-serif';
  const BLUE='#001b67', WINE='#80152e', INK='#141a33', MUT='#5d6275', LINE='#e4e0d7';
  x.fillStyle='#f6f4f0';x.fillRect(0,0,W,H);
  x.textBaseline='alphabetic';
  // wordmark
  x.font='800 30px '+F;const lw=x.measureText('TANNICO ').width, gw=x.measureText('A TAVOLA').width, lx=(W-(lw+gw))/2;
  x.textAlign='left';x.fillStyle=BLUE;x.fillText('TANNICO ',lx,96);x.fillStyle=WINE;x.fillText('A TAVOLA',lx+lw,96);
  x.textAlign='center';x.fillStyle=MUT;x.font='600 17px '+F;x.fillText('IL GIOCO DEGLI ABBINAMENTI',W/2,126);
  // occasione (+ data se sfida del giorno)
  x.fillStyle=INK;x.font='600 30px '+F;
  x.fillText((r.daily?'🎯 Sfida del giorno '+r.dayKey.split('-').reverse().join('/')+' · ':r.occEm+' ')+r.occName,W/2,180);
  // medaglia
  x.font='800 30px '+F;const rw=x.measureText(r.rank).width;const pw=rw+64,ph=60,px=(W-pw)/2,py=212;
  x.fillStyle=r.rankCol||'#e3e6ee';roundRect(x,px,py,pw,ph,30);x.fill();
  x.fillStyle=INK;x.fillText(r.rank,W/2,py+40);
  // punteggio: la cima delle cifre (≈0.72 del corpo) resta ~50px sotto la medaglia
  const scoreY=py+ph+50+Math.round(170*.72);
  x.font='800 170px '+F;const sw=x.measureText(String(r.total)).width;
  const suf='/ '+r.par+' pt';x.font='600 42px '+F;const fw=x.measureText(suf).width;
  const sx=(W-(sw+22+fw))/2;
  x.textAlign='left';x.font='800 170px '+F;x.fillStyle=BLUE;x.fillText(String(r.total),sx,scoreY);
  x.font='600 42px '+F;x.fillStyle=MUT;x.fillText(suf,sx+sw+22,scoreY);
  x.textAlign='center';x.fillStyle=MUT;x.font='500 26px '+F;
  x.fillText(Math.round(r.total/r.par*100)+'% del massimo possibile · spesi €'+eur(r.spent)+' su €'+r.budget,W/2,scoreY+56);
  // una card per portata, con l'icona del piatto
  const cardH=200,gap=24,cw=W-160,cx=80,top=scoreY+96,room=H-110-top;let y=top+Math.max(0,(room-(3*cardH+2*gap))/2);
  r.detail.forEach(d=>{
    const c=occ.courses[d.courseIdx];
    x.fillStyle='#fff';roundRect(x,cx,y,cw,cardH,20);x.fill();
    x.strokeStyle=LINE;x.lineWidth=2;roundRect(x,cx,y,cw,cardH,20);x.stroke();
    x.textAlign='center';x.font='56px '+F;x.fillText(c.em,cx+72,y+cardH/2+20);
    x.textAlign='left';
    x.fillStyle=BLUE;x.font='700 21px '+F;x.fillText(c.dish.toUpperCase(),cx+132,y+56);
    x.fillStyle=INK;x.font='500 30px "Fraunces","Georgia",serif';x.fillText(clip(d.wine.name,34),cx+132,y+106);
    const meta='€'+eur(d.wine.price)+'  ·  Tannico '+d.wine.giud+'pt'+(d.wine.premi&&d.wine.premi.length?'  ·  '+d.wine.premi[0]:'');
    x.fillStyle=MUT;x.font='22px '+F;x.fillText(meta,cx+132,y+152);
    x.textAlign='right';x.fillStyle=WINE;x.font='800 48px '+F;x.fillText(Math.round(d.pts)+'',cx+cw-34,y+112);
    x.fillStyle=MUT;x.font='600 20px '+F;x.fillText('punti',cx+cw-34,y+142);
    y+=cardH+gap;
  });
  x.textAlign='center';x.fillStyle=BLUE;x.font='600 24px '+F;
  x.fillText('Trova la selezione perfetta su tannico.it',W/2,H-50);
  return cv;
}
function downloadImage(){
  track('save_image',{mode:MODE, occasion:occ.id});
  const cv=buildShareCanvas();
  const a=document.createElement('a');a.download='tannico-a-tavola-risultato.png';a.href=cv.toDataURL('image/png');a.click();
  toast('Risultato salvato ✓');
}
function roundRect(c,x,y,w,h,r){c.beginPath();c.moveTo(x+r,y);c.arcTo(x+w,y,x+w,y+h,r);c.arcTo(x+w,y+h,x,y+h,r);c.arcTo(x,y+h,x,y,r);c.arcTo(x,y,x+w,y,r);c.closePath()}
function clip(s,n){return s.length>n?s.slice(0,n-1)+'…':s}

/* ====================== HERO MODE ====================== */
// pool di piatti = tutte le portate di tutte le occasioni (deduplicate), con l'occasione di origine
// (serve per pescare i "round difficili" dalle occasioni TRICKY)
const DISHES=(()=>{const seen=new Set(),out=[];for(const o of OCCASIONS)for(const c of o.courses){if(!seen.has(c.dish)){seen.add(c.dish);out.push({em:c.em,dish:c.dish,want:c.want,occId:o.id})}}return out})();
const BOSS_OCC=new Set(['piccante','affumicato','formaggi','tartufo']); // occasioni "tricky" usate per i round difficili
const HERO_THRESH=0.6;        // soglia base di "abbinamento giusto" (sale con lo streak, vedi heroThreshFor)
let heroStreak=0, heroDish=null, heroHand=[], heroLock=false;
let heroBag=[];                // shuffle-bag: pesca senza ripetizioni finché non hai visto tutti i piatti

// ESCALATION: la soglia di correttezza sale ogni 5 streak (max 0.8) — la 30ª mano è più dura della 1ª
function heroThreshFor(streak){ return Math.min(0.8, HERO_THRESH + Math.floor(streak/5)*0.04); }

function startHero(){ if(busy)return; track('start',{mode:'hero'}); MODE='hero'; RND=Math.random; heroStreak=0; heroLock=false; heroBag=[]; $('heroChoice').classList.add('hidden'); show('screen-hero'); nextHeroRound(); }
function nextHeroDish(){
  const lastDish = heroDish && heroDish.dish;
  if(heroBag.length===0){
    heroBag = sample(DISHES, DISHES.length);
    // evita che l'ultimo piatto del giro precedente ricapiti subito come primo del nuovo giro
    if(heroBag.length>1 && heroBag[0].dish===lastDish){
      const j=1+Math.floor(RND()*(heroBag.length-1));
      [heroBag[0],heroBag[j]]=[heroBag[j],heroBag[0]];
    }
  }
  return heroBag.pop();
}
function nextHeroRound(){
  heroLock=false; $('heroFeedback').className='hero-feedback'; $('heroFeedback').innerHTML='';
  $('heroChoice').classList.add('hidden');
  const thresh=heroThreshFor(heroStreak);
  // BOSS ROUND: ogni 5 di streak, un piatto pescato apposta dalle occasioni tricky
  const isBoss = heroStreak>0 && heroStreak%5===0;
  if(isBoss){
    const bossPool=DISHES.filter(d=>BOSS_OCC.has(d.occId));
    heroDish = bossPool.length ? sample(bossPool,1)[0] : nextHeroDish();
  } else {
    heroDish = nextHeroDish();
  }
  // mano da 8: GIUSTI (SIM>=soglia, sempre meno "paracadute" man mano che lo streak sale) + distrattori
  const safeCount = heroStreak>=10 ? 1 : 2;
  const right=WINES.filter(w=>SIM[w.style][heroDish.want]>=thresh);
  const wrong=WINES.filter(w=>SIM[w.style][heroDish.want]<thresh);
  heroHand=sample(right,safeCount).concat(sample(wrong,8-safeCount));
  // dedup + completa a 8
  const seen=new Set(); heroHand=heroHand.filter(w=>w&&!seen.has(w.name)&&seen.add(w.name));
  while(heroHand.length<8){const x=sample(WINES,1)[0]; if(!seen.has(x.name)){seen.add(x.name);heroHand.push(x)}}
  heroHand=sample(heroHand,8);
  $('heroStreak').textContent=heroStreak;
  $('heroBest').textContent=heroStats().best;
  $('heroDish').innerHTML=`<div class="hd-em">${heroDish.em}</div><div class="hd-name">${heroDish.dish}</div>${isBoss?'<div class="hero-boss-tag">🔥 Piatto difficile</div>':''}`;
  $('heroHand').innerHTML=heroHand.map((w,i)=>`<div class="bottle" onclick="TannicoATavola.heroPick(${i})">
    <div class="qmark"></div><div class="bglass">${glassSVG(w.style)}</div>
    <div class="bn-name">${w.name}</div><div class="styletag">${STYLE_LABEL[w.style]}</div>
    <div class="bn-meta"><span>${w.region||w.tip}</span><span class="pr">€${eur(w.price)}</span></div></div>`).join('');
}
function heroPick(i){
  if(heroLock) return; heroLock=true;
  const w=heroHand[i]; const a=abbinaScore(w.style, heroDish.want);
  const thresh=heroThreshFor(heroStreak);
  const cards=$('heroHand').children;
  if(a>=thresh){
    cards[i].classList.add('correct');
    sndCorrect();
    heroStreak++; $('heroStreak').textContent=heroStreak;
    $('heroFeedback').className='hero-feedback ok'; $('heroFeedback').innerHTML=`✓ Giusto! ${STYLE_LABEL[w.style]}, abbinamento centrato. Striscia: ${heroStreak} 🔥`;
    // PRESS-YOUR-LUCK: invece di avanzare in automatico, la scelta è tua — incassa o rischia
    $('heroBankVal').textContent=heroStreak;
    setTimeout(()=>$('heroChoice').classList.remove('hidden'), 500);
  } else {
    cards[i].classList.add('wrong');
    sndWrong();
    // evidenzia una scelta giusta
    let gi=heroHand.findIndex(x=>SIM[x.style][heroDish.want]>=thresh);
    if(gi>-1) cards[gi].classList.add('correct');
    heroGameOver(w);
  }
}
function heroContinue(){ $('heroChoice').classList.add('hidden'); nextHeroRound(); }
function heroBank(){
  $('heroChoice').classList.add('hidden');
  track('hero_end',{streak:heroStreak, banked:true});
  const st=recordHero(heroStreak);
  const isRecord = heroStreak>0 && heroStreak>=st.best;
  show('screen-heroover');
  $('heroOverMsg').textContent = isRecord ? '🎉 Nuovo primato incassato!' : '🏦 Striscia incassata!';
  $('heroFinalStreak').innerHTML=`<span id="heroStreakNum">0</span><small> di fila</small>`; countUp($('heroStreakNum'), heroStreak, 700);
  $('heroOverSub').innerHTML=`Hai incassato prima di rischiare troppo. Prudenza saggia, o potevi spingerti oltre?`;
  $('heroMiss').innerHTML='';
  renderHeroHistory();
  if(isRecord && heroStreak>0) launchConfetti();
}
function heroGameOver(wrongWine){
  track('hero_end',{streak:heroStreak, banked:false, dish:heroDish.dish});
  const st=recordHero(heroStreak);
  clearTimeout(heroTimer); heroTimer=setTimeout(()=>{
    show('screen-heroover');
    const isRecord = heroStreak>0 && heroStreak>=st.best;
    $('heroOverMsg').textContent = isRecord && heroStreak>0 ? '🎉 Nuovo primato!' : 'Partita finita';
    $('heroFinalStreak').innerHTML=`<span id="heroStreakNum">0</span><small> di fila</small>`; countUp($('heroStreakNum'), heroStreak, 700);
    $('heroOverSub').innerHTML=`Hai sbagliato su <b class="gold">${heroDish.dish}</b>: ${wrongWine.name} (${STYLE_LABEL[wrongWine.style]}) non era l’abbinamento giusto.`;
    $('heroMiss').innerHTML=`<h3>L’abbinamento ideale</h3><div class="opt-row"><span class="on">${heroDish.em} <b>${heroDish.dish}</b> → <span class="gold">${STYLE_LABEL[heroDish.want]}</span></span></div>`;
    renderHeroHistory();
    if(isRecord && heroStreak>0) launchConfetti();
  }, 1100);
}

/* ---- hero storage ---- */
function heroStats(){ let s; try{s=JSON.parse(localStorage.getItem('tannico_hero')||'{}')}catch(e){s={}} return {best:s.best||0, runs:s.runs||[]}; }
function recordHero(score){
  const s=heroStats();
  const best=Math.max(s.best,score);
  const runs=s.runs.slice(); runs.unshift({d:todayKey(), s:score}); runs.length=Math.min(runs.length,8);
  try{localStorage.setItem('tannico_hero',JSON.stringify({best,runs}))}catch(e){}
  return {best, runs};
}
function renderHeroHistory(){
  const s=heroStats();
  let rows=s.runs.map((r,idx)=>`<div class="opt-row"><span class="on">${r.s>=s.best&&r.s>0?'👑 ':'🍷 '}<b>${r.s}</b> di fila</span><span class="ov muted">${r.d.split('-').reverse().join('/')}</span></div>`).join('');
  if(!rows) rows=`<div class="opt-row"><span class="on muted">Nessuna gara ancora</span></div>`;
  $('heroHistory').innerHTML=`<h3>I tuoi primati · migliore ${s.best}</h3>`+rows;
}
function updateHeroHome(){ /* hook se in futuro vogliamo mostrare il best in home */ }

/* ====================== ART DIRECTOR PASS: eye candy ====================== */
// coriandoli CSS puri per i momenti "wow" (tris perfetto, nuovo primato) — nessun asset esterno
function launchConfetti(){
  const colors=['#d9a94a','#f0cf8e','#c0394f','#6f86c8','#4ec196'];
  const host=document.createElement('div'); host.className='confetti-host';
  for(let i=0;i<28;i++){
    const p=document.createElement('span');
    p.className='confetti-piece';
    p.style.left=(Math.random()*100)+'%';
    p.style.background=colors[i%colors.length];
    p.style.animationDelay=(Math.random()*0.3)+'s';
    p.style.animationDuration=(1.6+Math.random()*1)+'s';
    p.style.setProperty('--rot',(Math.random()*720-360)+'deg');
    p.style.setProperty('--drift',(Math.random()*160-80)+'px');
    host.appendChild(p);
  }
  ROOT.appendChild(host);
  setTimeout(()=>host.remove(),2800);
}
// count-up del punteggio: da 0 al valore finale, per un reveal più "game show"
function countUp(el, to, ms){
  const start=performance.now();
  function step(now){
    const t=Math.min(1,(now-start)/ms);
    const eased=1-Math.pow(1-t,3);
    el.textContent=Math.round(to*eased);
    if(t<1) requestAnimationFrame(step);
    else el.textContent=to;
  }
  requestAnimationFrame(step);
}
// audio sintetizzato via Web Audio API — zero asset esterni, solo feedback sonoro leggero
let audioCtx=null;
function getAudioCtx(){ if(!audioCtx){ try{audioCtx=new (window.AudioContext||window.webkitAudioContext)();}catch(e){} } return audioCtx; }
function playTone(freq,dur,type,vol,delay){
  const ctx=getAudioCtx(); if(!ctx) return;
  const t0=ctx.currentTime+(delay||0);
  const osc=ctx.createOscillator(), gain=ctx.createGain();
  osc.type=type||'sine'; osc.frequency.setValueAtTime(freq,t0);
  gain.gain.setValueAtTime(0,t0); gain.gain.linearRampToValueAtTime(vol||0.15,t0+0.01); gain.gain.exponentialRampToValueAtTime(0.001,t0+dur);
  osc.connect(gain); gain.connect(ctx.destination);
  osc.start(t0); osc.stop(t0+dur+0.02);
}
function sndPop(){ playTone(880,.05,'sine',.07); }
function sndCorrect(){ playTone(523.25,.12,'sine',.15); playTone(783.99,.16,'sine',.13,.08); }
function sndWrong(){ playTone(196,.28,'sine',.15); playTone(146.8,.3,'sine',.13,.05); }
function sndPerfect(){ [523.25,659.25,783.99,1046.5].forEach((f,i)=>playTone(f,.18,'triangle',.12,i*0.08)); }

initPool();
updateDailyInfo();
renderCareerPanel();

window.TannicoATavola = { acceptHand, buyLineup, clearSlot, closeShare, downloadImage, goHome, heroBank, heroContinue, heroPick, quitGame, rerollHand, reveal, selectSlot, shareResult, shareTo, startDaily, startFree, startHero, toggle, toggleTheme, useHint };